export function JointPositionSliderOverlay({
  actuatorSliderState,
  isDragging,
  onBlur,
  onPointerCancel,
  onPointerDown,
  onPointerMove,
  onPointerUp,
  onStopEvent,
  onValueChange,
  position,
  range,
  selectedJoint,
  selectedJointDef,
  step,
  value,
  visible,
}) {
  if (!visible || !position) return null;

  const labelPrefix = actuatorSliderState ? "Actuator target" : "Current position";
  const jointName = selectedJointDef?.name || selectedJoint;

  return (
    <>
      <input
        type="range"
        min={range[0]}
        max={range[1]}
        step={step}
        value={value}
        aria-label={`${labelPrefix} for joint ${jointName}`}
        className="joint-position-slider-native slider fixed z-[30]"
        style={{
          left: position.x,
          top: position.y,
          transform: "translateY(-50%)",
          accentColor: actuatorSliderState ? "#f97316" : undefined,
        }}
        onPointerDown={onPointerDown}
        onPointerMove={onPointerMove}
        onPointerUp={onPointerUp}
        onPointerCancel={onPointerCancel}
        onMouseDown={onStopEvent}
        onClick={onStopEvent}
        onBlur={onBlur}
        onInput={onValueChange}
        onChange={onValueChange}
      />
      {isDragging ? (
        <div
          className="pointer-events-none fixed z-[10000] inline-block rounded border border-gray-300/60 bg-gray-900/80 px-2 py-1 text-xs text-gray-100 shadow-md select-none whitespace-nowrap"
          style={{
            left: position.x + 112,
            top: position.y,
            transform: "translate(14px, -50%)",
          }}
        >
          {actuatorSliderState ? `Actuator target: ${value.toFixed(3)}` : value.toFixed(3)}
        </div>
      ) : null}
    </>
  );
}
